<template>
  <!-- VIEW LG -->
  <div class="min-[1086px]:grid hidden bg-header w-auto mr-10 ml-10 h-auto mt-36">
    <div class="bg-blue-maluku h-auto ml-20 mr-20 -mt-20 rounded-xl">
      <div class="flex justify-between px-12 py-11">
        <h1 class="text-white font-semibold text-2xl w-80">
          {{ $t("message.bantuan") }}
        </h1>
        <button class="hover:scale-110 duration-500 pl-11 pr-11 pt-4 pb-4 rounded-xl bg-black2 text-white">
          {{ $t("message.bantuan_btn") }}
        </button>
      </div>
    </div>
    <div class="grid ml-20 mr-20 -mt-20">
      <div class="flex justify-between">
        <!-- LOGO -->
        <div class="ml-3 mt-20">
          <div class="mt-3">
            <img v-img="'logo'" class="-ml-10 w-72 scale-75 cursor-pointer"
              :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="" />
          </div>
          <p class="w-52 text-sm leading-loose text-text-footer">
            {{ informasiDasar?.info_lain }}
          </p>
          <!-- <div
            v-html="informasiDasar?.info_lain.length > 150 ? `${informasiDasar?.info_lain.substring(0, 150)}...` : informasiDasar?.info_lain"
            class="w-52 text-sm leading-loose text-text-footer">

          </div> -->
          <div class="ml-1 mt-4">
            <div class="flex mt-2">
              <a v-if="informasiDasar?.facebook" :href="`http://www.facebook.com/${informasiDasar?.facebook}`"><img width="25" height="25"
                  class="hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/facebook-icon.svg" alt="" /></a>
              <a v-if="informasiDasar?.twitter" :href="`http://www.twitter.com/${informasiDasar?.twitter}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/twitter-icon.svg"
                  alt="" /></a>
              <a v-if="informasiDasar?.linkedln" :href="`http://www.linkedin.com/${informasiDasar?.linkedln}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/linkedin-icon.svg"
                  alt="" /></a>
                  <a v-if="informasiDasar?.instagram" :href="`http://www.instagram.com/${informasiDasar?.instagram}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/instagram.svg"
                  alt="" /></a>
            </div>
          </div>
        </div>
        <!-- KONTAK -->
        <div class="-ml-24">
          <div class="mt-28">
            <p class="text-footermain font-semibold">{{ $t("message.footer_kontak") }}</p>
            <p class="text-sm mt-3 text-footersecondary">{{ $t("message.telp") }} : {{ informasiDasar?.no_hp }}</p>
            <p class="text-sm mt-2 text-footersecondary">{{ $t("message.alamat") }} : {{
              $i18n.locale == 'id' ? informasiDasar?.alamat :
              informasiDasar?.alamat_en
            }}</p>
            <p class="text-sm mt-2 text-footersecondary">Email : {{ informasiDasar?.email }}</p>
            <p class="text-sm mt-2 text-footersecondary">Whatsapp : {{ informasiDasar?.wa }}</p>
            <p class="text-sm mt-2 text-footersecondary">Call Center : {{ informasiDasar?.call_center }}</p>
          </div>
        </div>
        <!-- LINKS -->
        <div class="mt-28">
          <p class="text-footermain font-semibold">{{ $t("message.footer_navigasi") }}</p>
          <router-link :to="{ name: 'landingpage' }">
            <p class="text-sm mt-3 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.beranda")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagebisnis' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.bisnis")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'tentang-perusahaan' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.perusahaan")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpageebanking' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">E-Banking</p>
          </router-link>
          <router-link :to="{ name: 'simulasi' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simulasi")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagjaringankantor' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.jaringan_kantor")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagekarir' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.karir")
            }}</p>
          </router-link>
        </div>
        <!-- LAYANAN -->
        <div class="mr-3 mt-28">
          <p class="text-footermain font-semibold">{{ $t("message.footer_layanan") }}</p>
          <router-link :to="{ name: 'landingpagebisnis' }">
            <p class="text-sm mt-4 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simpanan")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagpinjaman' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.pinjaman")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'simulasi' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simulasi")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagesukubunga' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.kurs")
            }}</p>
          </router-link>
        </div>
      </div>
      <img class="" src="@/assets/bola-bola.png" alt="" />
      <div class="h-px w-full bg-divider mt-0"></div>
      <div class="flex justify-between mt-3 text-sm mb-5">
        <div class="flex">Copyright @2022 Bank Maluku Malut</div>
      </div>
    </div>
  </div>

  <!-- VIEW MD -->
  <div class="min-[1058px]:grid min-[1086px]:hidden hidden bg-header w-auto h-96 mt-36 ml-10 mr-10">
    <div class="bg-blue-maluku h-auto ml-16 mr-16 -mt-20 rounded-xl">
      <div class="flex justify-between px-12 py-11">
        <h1 class="text-white font-semibold text-2xl w-80">{{ $t("message.bantuan") }}</h1>
        <button class="hover:text-biru cursor-pointer pl-11 pr-11 pt-4 pb-4 rounded-xl bg-black2 text-white">{{
          $t("message.bantuan_btn")
        }}</button>
      </div>
    </div>
    <div class="grid -mt-20 ml-16 mr-16">
      <div class="flex justify-between">
        <!-- LOGO -->
        <div class="ml-3 mt-24">
          <div class="mt-3">
            <img class="-ml-10 w-72 scale-75 cursor-pointer" :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="" />
          </div>
          <p class="w-44 text-sm leading-loose text-text-footer">
            {{ informasiDasar?.info_lain }}
          </p>
          <div class="ml-1 mt-4">
            <div class="flex mt-2">
              <a v-if="informasiDasar?.facebook"  :href="`http://www.facebook.com/${informasiDasar?.facebook}`"><img width="25" height="25"
                  class="hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/facebook-icon.svg" alt="" /></a>
              <a v-if="informasiDasar?.twitter" :href="`http://www.twitter.com/${informasiDasar?.twitter}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/twitter-icon.svg"
                  alt="" /></a>
              <a v-if="informasiDasar?.linkedln" :href="`http://www.linkedin.com/${informasiDasar?.linkedln}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/linkedin-icon.svg"
                  alt="" /></a>
                  <a v-if="informasiDasar?.instagram" :href="`http://www.instagram.com/${informasiDasar?.instagram}`"><img width="25" height="25"
                  class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/instagram.svg"
                  alt="" /></a>
            </div>
          </div>
        </div>
        <!-- KONTAK -->
        <div class="-ml-24">
          <div class="mt-28">
            <p class="text-footermain font-semibold">{{ $t("message.footer_kontak") }}</p>
            <p class="text-sm mt-3 text-footersecondary">{{ $t("message.telp") }} : {{ informasiDasar?.no_hp }}</p>
            <p class="text-sm mt-2 text-footersecondary">{{ $t("message.alamat") }} : {{
              $i18n.locale == 'id' ? informasiDasar?.alamat :
              informasiDasar?.alamat_en
            }}</p>
            <p class="text-sm mt-2 text-footersecondary">Email : {{ informasiDasar?.email }}</p>
            <p class="text-sm mt-2 text-footersecondary">Whatsapp : {{ informasiDasar?.wa }}</p>
            <p class="text-sm mt-2 text-footersecondary">Call Center : {{ informasiDasar?.call_center }}</p>
          </div>
        </div>
        <!-- LINKS -->
        <div class="mt-28">
          <p class="text-footermain font-semibold">{{ $t("message.footer_navigasi") }}</p>
          <router-link :to="{ name: 'landingpage' }">
            <p class="text-sm mt-3 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.beranda")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagebisnis' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.bisnis")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'tentang-perusahaan' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.perusahaan")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpageebanking' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">E-Banking</p>
          </router-link>
          <router-link :to="{ name: 'simulasi' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simulasi")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagjaringankantor' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.jaringan_kantor")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagekarir' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.karir")
            }}</p>
          </router-link>
        </div>
        <!-- LAYANAN -->
        <div class="mr-3 mt-28">
          <p class="text-footermain font-semibold">{{ $t("message.footer_layanan") }}</p>
          <router-link :to="{ name: 'landingpagebisnis' }">
            <p class="text-sm mt-4 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simpanan")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagpinjaman' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.pinjaman")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'simulasi' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.simulasi")
            }}</p>
          </router-link>
          <router-link :to="{ name: 'landingpagesukubunga' }">
            <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
              $t("message.kurs")
            }}</p>
          </router-link>
        </div>
      </div>
      <img class="" src="@/assets/bola-bola.png" alt="" />
      <div class="h-px w-full bg-divider mt-0"></div>
      <div class="flex justify-between mt-3 text-sm mb-5">
        <div class="flex">Copyright @2022 Bank Maluku Malut</div>
      </div>
    </div>
  </div>
  <!-- MOBILE FOOTER -->
  <div class="grid min-[1058px]:hidden min-[1086px]:hidden bg-header h-auto mt-28">
    <!-- BLUE BOX -->
    <div class="relative">
      <div class="w-full">
        <div
          class="px-8 absolute inset-0 grid grid-cols-2 place-content-center bg-blue-maluku h-40 -mt-20 mx-5 rounded-xl">
          <h1 class="text-white font-semibold text-sm w-44">{{ $t("message.bantuan") }}</h1>
          <div class="ml-5 rounded-xl bg-black2 text-white text-xs flex justify-center">
            <button class="hover:scale-110 duration-500 cursor-pointer ">{{
              $t("message.bantuan_btn")
            }}</button>
          </div>

        </div>
      </div>
    </div>
    <!-- KONTAK -->
    <div class="p-5 pt-28">
      <div class="">
        <p class="text-footermain font-semibold">{{ $t("message.footer_kontak") }}</p>
        <p class="text-sm mt-3 text-footersecondary">{{ $t("message.telp") }} : {{ informasiDasar?.no_hp }}</p>
        <p class="text-sm mt-2 text-footersecondary">{{ $t("message.alamat") }} : {{
          $i18n.locale == 'id' ? informasiDasar?.alamat :
          informasiDasar?.alamat_en
        }}</p>
        <p class="text-sm mt-2 text-footersecondary">Email : {{ informasiDasar?.email }}</p>
        <p class="text-sm mt-2 text-footersecondary">Whatsapp : {{ informasiDasar?.wa }}</p>
        <p class="text-sm mt-2 text-footersecondary">Call Center : {{ informasiDasar?.call_center }}</p>
      </div>
      <div class="ml-3 mt-4">
        <div class="flex mt-2">
          <a v-if="informasiDasar?.facebook" :href="`http://www.facebook.com/${informasiDasar?.facebook}`"><img width="25" height="25"
              class="hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/facebook-icon.svg" alt="" /></a>
          <a v-if="informasiDasar?.twitter" :href="`http://www.twitter.com/${informasiDasar?.twitter}`"><img width="25" height="25"
              class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/twitter-icon.svg" alt="" /></a>
          <a v-if="informasiDasar?.linkedln" :href="`http://www.linkedin.com/${informasiDasar?.linkedln}`"><img width="25" height="25"
              class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/linkedin-icon.svg" alt="" /></a>
              <a v-if="informasiDasar?.instagram" :href="`http://www.linkedin.com/${informasiDasar?.instagram}`"><img width="25" height="25"
                class="ml-2 hover:scale-110 duration-500 cursor-pointer" src="@/assets/icon/instagram.svg" alt="" /></a>
        </div>
      </div>
      <div class="mt-7">
        <p class="text-footermain font-semibold">{{ $t("message.footer_navigasi") }}</p>
        <router-link :to="{ name: 'landingpage' }">
          <p class="text-sm mt-3 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.beranda")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpagebisnis' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.bisnis")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'tentang-perusahaan' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.perusahaan")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpageebanking' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">E-Banking</p>
        </router-link>
        <router-link :to="{ name: 'simulasi' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.simulasi")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpagjaringankantor' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.jaringan_kantor")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpagekarir' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.karir")
          }}</p>
        </router-link>
      </div>
      <div class="mt-7">
        <p class="text-footermain font-semibold">{{ $t("message.footer_layanan") }}</p>
        <router-link :to="{ name: 'landingpagebisnis' }">
          <p class="text-sm mt-4 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.simpanan")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpagpinjaman' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.pinjaman")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'simulasi' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.simulasi")
          }}</p>
        </router-link>
        <router-link :to="{ name: 'landingpagesukubunga' }">
          <p class="text-sm mt-2 text-footersecondary hover:text-biru cursor-pointer">{{
            $t("message.kurs")
          }}</p>
        </router-link>
      </div>
      <div class="mt-3">
        <img v-img="'logo'" class="-ml-9 scale-75" :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="" />
      </div>
      <p class="text-sm leading-loose text-text-footer">
        {{ informasiDasar?.info_lain }}
      </p>
      <div class="">
        <img class="" src="@/assets/bola-bola.png" alt="" />
        <div class="h-px w-full bg-divider mt-0"></div>
        <div class="flex justify-between mt-3 text-sm mb-5">
          <div class="flex">Copyright @2022 Bank Maluku Malut</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["informasiDasar"],
  setup() { },
};
</script>
